export const API_URL = process.env.REACT_APP_API_URL || '';

// MSAL configuration
export const MSAL_CLIENT_ID = process.env.REACT_APP_MSAL_CLIENT_ID || '';
export const MSAL_AUTHORITY = process.env.REACT_APP_MSAL_AUTHORITY || '';
export const MSAL_REDIRECT_URI = process.env.REACT_APP_MSAL_REDIRECT_URI || 'http://localhost:3000/';

export const PROJECT_TYPES = [
  'single',
  'panorama',
  'video',
  'mill',
  'forest',
];

export const MULTIMEDIA_TYPES = [
  'single',
  'panorama',
  'video',
]
export const DRONE_TYPES = [
  'mill',
  'forest'
]

// map feature attributes
export const FEATURE_KEY_ID = 'id';
export const FEATURE_KEY_NAME = 'name';